"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gtm = {
    /**
     * Load the Google Tag Manager script
     * @example
     * var {load} = require("gtm")
     * axios.get('https:[tenant].auth0.com/userinfo', {headers}).then(res => res.data.id)
     * .then(user_id => load({accountId:"GTM-234982342342", user_id}))
     *
     * OR
     *
     * Promise.all([
     * load({accountId:"GTM-234982342342"}),
     * axios.get('https:[tenant].auth0.com/userinfo', {headers}).then(res => res.data.id)
     * ]).then(([dataLayer, user_id]) => {
     *  dataLayer.push({user_id})
     * })
     */
    load: function (options) {
        var context = window;
        var accountId = options && options.accountId;
        var userId = options && options.userId;
        var namespace = options && options.namespace;
        var selector = "script";
        var name = namespace || "dataLayer";
        context[name] = context[name] || [];
        context[name].push({
            "gtm.start": new Date().getTime(),
            // tslint:disable-next-line:object-literal-sort-keys
            "event": "gtm.js",
        });
        if (userId) {
            context[name].push({
                user_id: userId,
            });
        }
        var firstScript = document.getElementsByTagName(selector)[0];
        var googleTmScript = document.createElement(selector);
        var nameParameter = name !== "dataLayer" ? "&l=" + name : "";
        googleTmScript.async = true;
        return new Promise(function loadGtm(resolve, reject) {
            googleTmScript.onload = function gtmLoaded() {
                resolve(context[name]);
            };
            googleTmScript.onerror = function gtmFailed(err) {
                reject(err);
            };
            googleTmScript.src =
                "https://www.googletagmanager.com/gtm.js?id=" +
                    accountId +
                    nameParameter;
            if (firstScript && firstScript.parentNode) {
                firstScript.parentNode.insertBefore(googleTmScript, firstScript);
            }
        });
    },
    /**
     * Render this on the server side, because otherwise it is pointless.
     * @param {string} accountId
     * @param {string} user_id
     *
     */
    noscript: function (_a) {
        var accountId = _a.accountId, userId = _a.userId;
        return "<noscript>\n<iframe\nsrc=\"https://www.googletagmanager.com/ns.html?id=" + accountId + "&user_id=" + userId + "\"\nheight=\"0\"\nwidth=\"0\"\nstyle=\"display:none;visibility:hidden\"\n/>\n</noscript>";
    },
};
// support es6
Object.defineProperty(gtm, "__esModule", { value: true });
Object.defineProperty(gtm, "default", { value: gtm });
exports.default = gtm;
